import { theme } from '@Guidelines/Theme/theme';
import { PermissionEnum } from '@Application/Security/Roles';
import { openDocumentToDelete } from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentDetails/Signals/documentToDeleteSignal';
import WithPermission from '@UI/Providers/PermissionProvider/WithPermission';
import { css } from '@emotion/react';
import { Trash2 } from 'lucide-react';
import * as React from 'react';
import { useSelector } from '@verclam/synapse';
import { Button, Tooltip } from '@verclam/ui-kit';
import ConditionalLoader from '@Guidelines/Component/Loader/ConditionalLoader';

const actionStyle = css`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;

	@media (max-width: ${theme.layout.compactBreakpoint}) {
		align-items: stretch;
	}
`;

/**
 * "Supprimer le document": gated by `DOCUMENT_DELETE`, disabled when
 * `canDelete` is `false`, the server's reason being the button's tooltip — the rule itself is never recomputed here. The dialog is mounted by the screen.
 */
const DeleteDocumentAction: React.FC = () => {
	const document = useSelector((state) => state.documentsStore.document);

	const documentId = document?.id ?? null;

	const handleClick = React.useCallback(() => {
		if (documentId !== null) {
			openDocumentToDelete(documentId);
		}
	}, [documentId]);

	return (
		<WithPermission permission={PermissionEnum.DOCUMENT_DELETE}>
			<ConditionalLoader data={document}>
				{(loadedDocument) => (
					<div css={actionStyle}>
						<Tooltip content={loadedDocument.deletionBlockedReason ?? ''} showOnDisabled>
							<Button
								type="button"
								text
								severity="danger"
								label="Supprimer le document"
								icon={<Trash2 size={16} />}
								disabled={!loadedDocument.canDelete}
								onClick={handleClick}
							/>
						</Tooltip>
					</div>
				)}
			</ConditionalLoader>
		</WithPermission>
	);
};

export default DeleteDocumentAction;
